import { newUid } from "@/lib/helpers";

export default {
  state: {
    dynPanelStack: []
  },
  mutations: {
    pushPanel(state, {uid, clazz, props = {}, on = {}, remove}) {
      state.dynPanelStack = [
        ...state.dynPanelStack,
        {
          uid, clazz, props,
          on: {
            cancel({emitter}) { emitter.remove(); },
            commit({emitter}) { emitter.remove(); },
            ...on
          },
          remove
        }
      ];
    },
    popPanel(state, {uid}) {
      state.dynPanelStack = state.dynPanelStack.filter(p => p.uid !== uid);
    }
  },
  actions: {
    pushPanel(store, panel) {
      const uid = newUid.next().value;
      store.commit(
        "pushPanel",
        {
          ...panel,
          uid,
          remove: () => store.dispatch("popPanel", {uid})
        }
      );
    },
    popPanel(store, panel?) {
      store.commit("popPanel", panel);
    }
  }
};